<template>
  <div class="content">
    <div class="modal-header border-0 custom-modal-header">
      <div class="page-title">
        <h4>Add Cash to Admin Account</h4>
      </div>
      <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body custom-modal-body">
      <form @submit.prevent="addCash">
        <div class="row">
          <div class="col-lg-6">
            <div class="mb-3">
              <label for="cash_date" class="form-label">Date</label>
              <input
                v-model="form.cash_date"
                type="date"
                id="cash_date"
                class="form-control"
                :class="{ 'is-invalid': errors.cash_date }"
              >
              <div v-if="errors.cash_date" class="invalid-feedback">
                {{ errors.cash_date[0] }}
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="mb-3">
              <label for="amount" class="form-label">Amount</label>
              <input
                v-model.number="form.amount"
                type="number"
                step="0.01"
                id="amount"
                class="form-control"
                :class="{ 'is-invalid': errors.amount }"
                placeholder="Enter cash amount"
                min="0.01"
              >
              <div v-if="errors.amount" class="invalid-feedback">
                {{ errors.amount[0] }}
              </div>
            </div>
          </div>

          <div class="col-lg-12">
            <div class="mb-3">
              <label for="source" class="form-label">Source</label>
              <select
                v-model="form.source"
                id="source"
                class="form-control"
                :class="{ 'is-invalid': errors.source }"
              >
                <option value="">Select Source</option>
                <option value="bank_deposit">Bank Deposit</option>
                <option value="cash_deposit">Cash Deposit</option>
                <option value="business_income">Business Income</option>
                <option value="loan">Loan</option>
                <option value="investment">Investment</option>
                <option value="other">Other</option>
              </select>
              <div v-if="errors.source" class="invalid-feedback">
                {{ errors.source[0] }}
              </div>
            </div>
          </div>

          

          <!-- Current Admin Balance Display -->
          <div class="col-lg-12 mb-3">
            <div class="alert alert-info">
              <strong>Current Admin Balance: </strong>
              <span class="text-success">{{ formatCurrency(currentBalance) }}</span>
            </div>
          </div>
        </div>

        <div class="modal-footer-btn">
          <a href="javascript:void(0);" class="btn btn-cancel me-2" data-bs-dismiss="modal">
            Cancel
          </a>
          <button type="submit" class="btn btn-submit" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
            Add Cash
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { showSuccessMessage, showErrorMessage } from '../utils/notifications.js';

export default {
  name: 'AdminCashAdd',

  data() {
    return {
      form: {
        amount: '',
        cash_date: new Date().toISOString().split('T')[0],
        source: '',
        description: ''
      },
      currentBalance: 0,
      errors: {},
      loading: false,
      initialLoading: true
    };
  },

  async mounted() {
    console.log('AdminCashAdd component mounted');

    // Mark element as mounted
    this.$el.closest('[data-vue-component]')?.classList.add('vue-mounted');

    await this.loadCurrentBalance();
    this.initialLoading = false;
  },

  methods: {
    async loadCurrentBalance() {
      try {
        const response = await this.$http.get('/api/admin/cash/balance');

        if (response.data.success) {
          this.currentBalance = response.data.balance;
        } else {
          this.showErrorMessage('Failed to load current balance');
        }
      } catch (error) {
        console.error('Failed to load balance:', error);
        this.showErrorMessage('Failed to load current balance');
      }
    },

    async addCash() {
      this.loading = true;
      this.errors = {};

      try {
        const response = await this.$http.post('/api/admin/cash/add', this.form);

        if (response.data.success) {
          this.showSuccessMessage(response.data.message);

          // Update current balance
          this.currentBalance = response.data.new_balance;

          // Close modal and refresh page
          setTimeout(() => {
            const modal = bootstrap.Modal.getInstance(document.getElementById('cashAddModal'));
            if (modal) {
              modal.hide();
            }
            window.location.reload();
          }, 1500);
        } else {
          this.showErrorMessage(response.data.message || 'Failed to add cash');
        }

      } catch (error) {
        console.error('Admin cash add failed:', error);

        if (error.response?.status === 422) {
          this.errors = error.response.data.errors || {};
          this.showErrorMessage('Please check the form for errors');
        } else if (error.response?.status === 403) {
          this.showErrorMessage('Unauthorized action. Admin access required.');
        } else {
          this.showErrorMessage(
            error.response?.data?.message || 'An error occurred while adding cash'
          );
        }
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.form = {
        amount: '',
        cash_date: new Date().toISOString().split('T')[0],
        source: '',
        description: ''
      };
      this.errors = {};
    },

    formatCurrency(amount) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'BDT',
        minimumFractionDigits: 2
      }).format(amount || 0);
    },

    showSuccessMessage,
    showErrorMessage
  }
};
</script>

<style scoped>
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.vue-component-loading {
  display: none;
}

.alert-info {
  background-color: #e7f3ff;
  border-color: #b3d7ff;
  color: #004085;
}

.text-success {
  font-weight: bold;
  font-size: 1.1em;
}
</style>
